import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { dispatch } from 'store'
import { orderDeliveryButton } from 'images'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://www.skipthedishes.com/yale-sushi?serviceType=delivery&utm_source=google&utm_medium=organic&utm_campaign=foodorder`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  w="80%"
                  minWidth="280px"
                  alt="About"
                />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://www.skipthedishes.com/yale-sushi?serviceType=delivery&utm_source=google&utm_medium=organic&utm_campaign=foodorder`}
            >
              <CFView hover>
                <CFImage
                  src={orderDeliveryButton}
                  maxWidth="350px"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
